export interface DeepLinkConfig {
  path: string;
  searchParams?: string[];
  deeplinkPath: string;
  deeplinkSearchParams?: string[];
}

export const DEEPLINK_CONFIGS: DeepLinkConfig[] = [
  {
    path: "/document-management/employee/:employeeId",
    searchParams: ["tab", "documentIdToSign", "documentIdToShow", "selectedEmployeeId"],
    deeplinkPath: "/pending-issues",
    deeplinkSearchParams: [
      "selectedEmployeeId",
      "documentIdToSign",
      "documentIdToShow",
    ],
  },
];
